import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ref',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './ref.component.html',
  styleUrl: './ref.component.css',
})
export class RefComponent {
  image = input.required<{ src: string; alt: string; link: string }>();
  company = input.required<string>();
  pdf = input.required<string>();
  //list = input.required<{}>();
}
